import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of, Subscriber} from 'rxjs';
import {PortalGeneralSetting} from '@models/adminstration/organization/constants/portal-general-setting';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {shareReplay} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private readonly BASE_URL: string;
  private PORTAL_SETTINGS_LIST_SUFFIX: string = '/api/web/application/settings';
  private PORTAL_SETTINGS_FIND_SUFFIX: string = '/api/web/application/settings/find?searchKey=:searchKey';
  private ENABLE_LIVE_DATA_STREAMING: string = 'ENABLE_LIVE_DATA_STREAMING';
  private ENABLE_CHART_DATA_STREAMING_TO_INFLUX_DB: string = 'ENABLE_CHART_DATA_STREAMING_TO_INFLUX_DB';

  private portalSettingResponseCache = new Map();

  constructor(private http: HttpClient,
              private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public listPortalSettings(): Observable<any> {
    const url: string = this.BASE_URL + this.PORTAL_SETTINGS_LIST_SUFFIX;
    return this.http.get<PortalGeneralSetting[]>(url, HTTPS_REQUEST_OPTIONS);
  }

  public findPortalSetting(propertyName: string): Observable<any> {
    let url: string = this.BASE_URL + this.PORTAL_SETTINGS_FIND_SUFFIX;
    url = url.replace(':searchKey', propertyName);
    const portalSettingFromCache = this.portalSettingResponseCache.get(propertyName);
    if (portalSettingFromCache) {
      return of(portalSettingFromCache);
    }

    const response = this.http.get<PortalGeneralSetting[]>(url, HTTPS_REQUEST_OPTIONS).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));

    response.subscribe((result) => {
      this.portalSettingResponseCache.set(propertyName, result);
    });

    return response;
  }

  public isLiveDataStreamingEnabled(): Observable<boolean> {
    return new Observable<boolean>((observer: Subscriber<any>) => {
      this.findPortalSetting(this.ENABLE_LIVE_DATA_STREAMING).subscribe({
        next: result => {
          if (!result || !result.name || result?.name?.length === 0 || result.value?.toUpperCase() === 'TRUE') {
            observer.next(true);
          } else {
            observer.next(false);
          }
          observer.complete();
        },
        error: _err => {
          observer.next(true);
          observer.complete();
        }
      });
    });
  }

  public isInfluxStreamingEnabled(): Observable<boolean> {
    return new Observable<boolean>((observer: Subscriber<any>) => {
      this.findPortalSetting(this.ENABLE_CHART_DATA_STREAMING_TO_INFLUX_DB).subscribe({
        next: result => {
          if (result?.value?.toUpperCase() === 'TRUE') {
            observer.next(true);
          } else {
            observer.next(false);
          }
          observer.complete();
        },
        error: _err => {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }

}
